import Layout from '@/views/layout'

export default {
  path: '/settle',
  name: 'Settle',
  meta: {
    id: 'E',
    title: '欧美电商提款'
  },
  component: Layout,
  children: [
    {
      path: 'settle-menage',
      name: 'SettleMenage',
      meta: {
        id: '110',
        title: '欧美电商提款',
        hiddenTitle: true
      },
      component: () => import('@/views/settle'),

      children: [
        {
          path: 'launch-settle',
          name: 'LaunchSettle',
          meta: {
            id: '20210427',
            title: '申请提款'
          },
          component: () => import('@/views/settle'),
          redirect: '/settle/settle-menage/launch-settle/statement',
          children: [
            // 申请提款声明
            {
              path: 'statement',
              name: 'SettleStatement',
              meta: {
                title: ''
              },
              component: () => import('@/views/settle/launchSettle/index')
            },
            // 交易步骤
            {
              path: 'step',
              name: 'SettleStep',
              meta: {
                title: ''
              },
              component: () => import('@/views/settle/launchSettle/step')
            }
          ]
        },
        {
          path: 'settle-records',
          name: 'SettleRecords',
          meta: {
            id: '20210428',
            title: '提款记录'
          },
          component: () => import('@/views/settle'),
          redirect: '/settle/settle-menage/settle-records/list',
          children: [
            {
              path: 'list',
              name: 'SettleRecordsList',
              meta: {
                title: '提款记录'
              },
              component: () => import('@/views/settle/settleRecords/list')
            },
            {
              path: 'details',
              name: 'SettleRecordsDetails',
              meta: {
                title: '提款记录'
              },
              component: () => import('@/views/settle/settleRecords/details')
            },
            {
              path: 'apply-withdrawal',
              name: 'SettleRecordsApplyWithdrawal',
              meta: {
                title: '申请提现'
              },
              component: () => import('@/views/settle/launchSettle/applyWithdrawal')
            }

          ]
        },
        {
          path: 'receiver-menage',
          name: 'ReceiverMenage',
          meta: {
            id: '20210429',
            title: '收款人管理'
          },
          component: () => import('@/views/settle'),
          redirect: '/settle/settle-menage/receiver-menage/list',
          children: [
            {
              path: 'list',
              name: 'ReceiverMenageList',
              meta: {
                title: ''
              },
              component: () => import('@/views/settle/receiverMenage/list')
            },
            {
              path: 'details',
              name: 'ReceiverMenageDetails',
              meta: {
                title: '收款人详情'
              },
              component: () => import('@/views/settle/receiverMenage/details')
            },
            {
              path: 'add',
              name: 'ReceiverMenageAdd',
              meta: {
                title: '新增收款人'
              },
              component: () => import('@/views/settle/receiverMenage/add')
            },
            {
              path: 'modify',
              name: 'ReceiverMenageModify',
              meta: {
                title: '变更银行卡'
              },
              component: () => import('@/views/settle/receiverMenage/modify')
            },
            {
              path: 'resubmit',
              name: 'ReceiverMenageResubmit',
              meta: {
                title: '变更银行卡'
              },
              component: () => import('@/views/settle/receiverMenage/resubmit')
            },
            {
              path: 'result',
              name: 'ReceiverMenageResult',
              meta: {
                title: '收款人管理结果'
              },
              component: () => import('@/views/settle/receiverMenage/result')
            }
          ]
        }
      ]
    }
  ]
}
